import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';
import { UserProfileService } from './components/mesc/mesc.service';
import { Router, NavigationCancel } from '@angular/router';

class UserProfile {
    GMIN: string;
    Name: string;
    ModuleClaims: string[];
    PermissionClaims: string[];
    GroupClaims: string[];
}

export const Module = {
    MESC: 'MESC',
    CAMTL: 'CAMTL',
    TNTS: 'TNTS',
    CTWR: 'CTWR',
    EWOMCR: 'EWOMCR',
    TPRECM: 'TPRECM'
}

const AdminUserGroups = {
    MESC_Admin: 'MESC',
    MESC_CAMTL_User_Administrator: 'CAMTL',
    MESC_TNTS_User_Administrator: 'TNTS',
    MESC_CTWR_User_Administrator: 'CTWR',
    MESC_EWOMCR_User_Administrator: 'EWOMCR',
    MESC_TPRECM_User_Administrator: 'TPRECM'
}


@Injectable()
export class AuthenticationService {
    private currentUser: any;
    private currentRoute: any;

    constructor(private userProfileService: UserProfileService, private router: Router) {
        userProfileService.subscribe(x => {
            this.currentUser = Array.isArray(x) ? x[0] : x;
        });
        userProfileService.read('', true)
            .then(response => {
                router.navigate([this.currentRoute]);
            })
        router.events.subscribe(e => {
            if (e instanceof NavigationCancel && !this.currentUser) {
                this.currentRoute = e.url;
            }
        });
    }


    /**
     * 
     * @param url 
     */
    public isClaimValid(url: string): boolean {
        let response: boolean;
        if (!this.currentUser) return false;

        if (!this.isValidUser()) {
            this.router.navigate(['/unauthorized']);
            return false;
        }

        try {
            let path = url.split('/');
            path.shift(); // Remove ''
            path.shift(); // Remove 'MESC'
            if (path.length === 0) return true;
            let isAdminPath: boolean = path.some(x => x.toLowerCase().includes('admin'));
            response = this.isGroupAdmin(path) || !isAdminPath && this.currentUser.ModuleClaims.indexOf(path[0]) > -1;
        } catch (e) { }
        return response;
    }


    /**
     * 
     * @param path 
     * 
     * example: /MESC/TNTS/Administration
     */
    private isGroupAdmin(path: string[]): boolean {
        let pathModule = path[0].toLowerCase();
        return this.currentUser.GroupClaims.some(x => {
            try {
                let claim: string[] = x.split('_'),
                    claimGroup: string = claim.pop().toLowerCase(),
                    claimModule: string = claim.pop().toLowerCase();

                let isValidAdmin: boolean = false,
                    isUserAdmin = claimGroup.includes('admin') && claimModule.includes('user'),
                    isSuperUser = claimGroup.includes('superuser'),
                    isSpecialUser = claimGroup.includes('specialuser'),
                    isSystemAdmin = claimGroup.includes('systemadmin'),
                    isMescAdmin = claimGroup === 'admin';

                switch (pathModule) {
                    case 'administration':
                        if (path[1]) {
                            if (path[1].toLowerCase() === 'security') {
                                isValidAdmin = isMescAdmin || isUserAdmin;
                            } else if (path[1].toLowerCase() === 'maintenance') {
                                isValidAdmin = isMescAdmin;
                            }
                        } else {
                            isValidAdmin = isMescAdmin || isUserAdmin;
                        }
                        break;
                    case 'camtl':
                        isValidAdmin = isSuperUser;
                        break;
                    case 'tnts':
                        isValidAdmin = this.isTntsAdmin(path, isSpecialUser, isSystemAdmin);
                        break;
                    default:
                        isValidAdmin = isMescAdmin;
                        break;
                }
                return isValidAdmin;
            } catch (e) { }
        })
    }

    public getAdminUserGroups(): any[] {
        return this.currentUser.GroupClaims.map(x => Module[AdminUserGroups[x]])
    }


    private isTntsAdmin(path, isSpecialUser, isSystemAdmin): boolean {
        let isAdmin: boolean = false;
        if (path.some(x => x.toLowerCase()
            .includes('specialuser'))) {
            isAdmin = isSpecialUser;
        } else if (path.some(x => x.toLowerCase()
            .includes('systemadmin'))) {
            isAdmin = isSystemAdmin;
        } else {
            let isToolIdentificationMatrix: boolean = false;
            isToolIdentificationMatrix = path.some(x => x.toLowerCase()
                .includes('toolidentificationmatrix'));
            isAdmin = !isToolIdentificationMatrix && isSpecialUser || isSystemAdmin;
        }
        return isAdmin;
    }


    private isValidModuleAdmin(path: string[], check: string, adminGroup: boolean): boolean {
        return adminGroup && path.some(x => x.includes(check));
    }


    private isValidUser(): boolean {
        return this.currentUser.GroupClaims.length > 0 || this.currentUser.ModuleClaims.length > 0;
    }

}
